export function historyBuilderForMyCRM(entity) {
  return {
    CreatedDate: entity.dateCreated,
    CreatedBy: entity.createdBy,
    LastModifiedDate: entity.dateUpdated,
    ModifiedBy: entity.updatedBy,
    SourcePlatformDescription: entity.sourcePlatform,
  };
}
